import request from '../request';

export default {
  namespaced: true,
  state: {
    loading: false,
    loaded: false,
    data: {},
  },

  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setLoaded(state, loaded) {
      state.loaded = loaded;
    },
    setList(state, list) {
      state.data = list;
    },
  },
  actions: {
    get(context) {
      return new Promise((resolve) => {
        const { app } = context.rootState;
        context.commit('setLoading', true);
        context.commit('setLoaded', false);
        const jwt = context.rootState.user.data.jwt;

        request.make(
          {
            type: 'GET',
            url: `${app.API_URL}${context.rootState.language}/${app.endpoints.ORDER_HISTORY}?_=${jwt}`,
          },
          (err, res) => {
            context.commit('setLoading', false);
            if (res.status === 200) {
              if (typeof res.body !== 'undefined') {
                context.commit('setLoaded', true);
                context.commit('setList', res.body.data);
                resolve();
              }
            } else {
              context.commit('setLoaded', false);
            }
          }
        );
      });
    },
  },
};
